var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductWarrenty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7808 24.4258L12.0031 24.5L12.2256 24.4258C18.1355 22.456 21.1469 17.5817 21.1469 12.5048V3.31415H18.7954C13.9984 3.31415 12.2783 0.65564 12.0031 0.5C11.7345 0.651794 10.0012 3.31415 5.21082 3.31415H2.85938V12.5048C2.85938 17.5744 5.85095 22.4494 11.7808 24.4258ZM4.26617 4.72076H5.21082C7.92719 4.72076 10.2599 3.93872 12.0031 2.45154C13.7463 3.93872 16.079 4.72076 18.7954 4.72076H19.7402V12.5048C19.7402 16.291 17.7019 21.0131 12.0031 23.0152C6.30432 21.0131 4.26617 16.291 4.26617 12.5048V4.72076Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0031 18.8351C15.4937 18.8351 18.3334 15.9953 18.3334 12.5048C18.3334 9.01422 15.4937 6.17444 12.0031 6.17444C8.51257 6.17444 5.67279 9.01422 5.67279 12.5048C5.67279 15.9953 8.51257 18.8351 12.0031 18.8351ZM12.0031 7.58124C14.718 7.58124 16.9266 9.78986 16.9266 12.5048C16.9266 15.2197 14.718 17.4283 12.0031 17.4283C9.28821 17.4283 7.07959 15.2197 7.07959 12.5048C7.07959 9.78986 9.28821 7.58124 12.0031 7.58124Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.314 11.5955L14.3192 10.6006L11.2998 13.6201L9.68701 12.0074L8.69238 13.0021L11.2998 15.6095L15.314 11.5955Z",
    fill: "#737373"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductWarrenty);
export default __webpack_public_path__ + "static/media/Product_Warrenty.9063c90f1d4d1786fa3e9cc0ca309a66.svg";
export { ForwardRef as ReactComponent };